import {copyToClipboard} from '@malt/dom';
import {pushNotification} from '@malt/joy-v2/src/js/notification';

export class CopyToClipBoard {
    constructor(root) {
        this.init(root);
    }

    init(root) {
        this.root = root;
        this.copyBtn = root.querySelector('.js-copy-btn');
        this.tryToCopy = this.tryToCopy.bind(this);
        this.contentToCopy = this.getContentToCopy();
        this.listenToUserAction();
    }

    getContentToCopy() {
        if (this.copyBtn.hasAttribute('data-copy-target')) {
            return document.querySelector(this.copyBtn.getAttribute('data-copy-target'));
        } else {
            return this.root.querySelector('.js-content-to-copy');
        }
    }

    getCopyBtnDataToggleText() {
        return this.copyBtn.getAttribute('data-toggle-text');
    }

    getCopyBtnDataOriginalText() {
        return this.copyBtn.getAttribute('data-original-text');
    }

    listenToUserAction() {
        this.copyBtn.addEventListener('click', this.tryToCopy);
    }

    destroy() {
        this.copyBtn.removeEventListener('click', this.tryToCopy);
    }

    tryToCopy(e) {
        e.preventDefault();

        try {
            this._copyToClipboard();
            this._notifySuccess();
            this._toggleCopyTextOnClickIfRequired();
        } catch (err) {
            this._notifyError(err);
        }
    }

    _copyToClipboard() {
        copyToClipboard(this.contentToCopy.value, this.root);
    }

    _notifySuccess() {
        pushNotification(Hop.message('copy.to.clipboard.message'), {
            level: 'success',
            duration: 1500,
            closable: false,
        });
    }

    _notifyError(err) {
        pushNotification(err, {
            level: 'error',
        });
    }

    _toggleCopyTextOnClickIfRequired() {
        if (this._checkIfCopyBtnHasToggleAttribute() && this._checkIfCopyBtnHasOriginalTextAttribute()) {
            this._toggleCopyTextOnClick();
        }
    }

    _toggleCopyTextOnClick() {
        const originalText = this.getCopyBtnDataOriginalText();

        this.copyBtn.textContent = this.getCopyBtnDataToggleText();
        this.copyBtn.setAttribute('disabled', 'disabled');

        setTimeout(() => {
            this.copyBtn.textContent = originalText;
            this.copyBtn.removeAttribute('disabled');
        }, 1500);
    }

    // Add a data-toggle-text attribute if you want to change your button text on click
    _checkIfCopyBtnHasToggleAttribute() {
        return this.copyBtn.hasAttribute('data-toggle-text');
    }

    _checkIfCopyBtnHasOriginalTextAttribute() {
        return this.copyBtn.hasAttribute('data-original-text');
    }
}

Hop.defineModule('copy-content-to-clipboard', (domRoot) => {
    const component = new CopyToClipBoard(domRoot);

    return function destroy() {
        component.destroy();
    };
});
